export const API_KEY = process.env.VUE_APP_GOOGLE_MAP_API_KEY;
